import { useEffect, useState } from 'react';

// min-width rather than max-width so the jsdom matchMedia stub in setupTests
// (which reads innerWidth) answers it.
const WIDE_QUERY = '(min-width: 768px)';

/** Below md the pick tables give way to cards. */
export function useWide(): boolean {
  const [wide, setWide] = useState(() => typeof window === 'undefined' || !!window.matchMedia?.(WIDE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia?.(WIDE_QUERY);
    if (!mq) return undefined;
    const on = () => setWide(mq.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  return wide;
}
